<template>
  <div class="grouped-summary p-3 mb-3">
    <div class="row align-items-center summary-row">
      <div class="col-12 col-md-4 summary-item px-4">
        <div class="color-black font-14">Total de Pagos Procesados:</div>
        <div class="color-black font-weight-bold font-20 mt-1">
          {{ value.totalProcessedPayments }}
        </div>
      </div>
      <div class="col-12 col-md-4 summary-item mt-3 mt-md-0">
        <div class="d-flex align-items-center justify-content-between px-4">
          <div>
            <div class="color-black font-14">
              Total de Estudiantes Procesados:
            </div>
            <div class="color-black font-weight-bold font-20 mt-1">
              {{ value.totalProcessedStudents }}
            </div>
          </div>
          <svg
            class="summary-donut"
            viewBox="0 0 36 36"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="donut-track"
              cx="18"
              cy="18"
              fill="none"
              r="15.9"
              stroke="#e9ecef"
              stroke-width="3.2"
            />
            <circle
              class="donut-segment"
              cx="18"
              cy="18"
              fill="none"
              r="15.9"
              stroke="#FDAC41"
              stroke-dasharray="100 0"
              stroke-dashoffset="25"
              stroke-linecap="round"
              stroke-width="3.2"
            />
            <text
              class="donut-label"
              dominant-baseline="middle"
              fill="#333"
              font-size="8"
              font-weight="bold"
              text-anchor="middle"
              x="18"
              y="18"
            >
              {{ processedPercent }}%
            </text>
          </svg>
        </div>
      </div>
      <div class="col-12 col-md-4 summary-item mt-3 mt-md-0">
        <div class="d-flex align-items-center justify-content-between  px-4">
          <div>
            <div class="color-black font-14">
              Total de Estudiantes Pagados:
            </div>
            <div class="color-black font-weight-bold font-20 mt-1">
              {{ value.totalPaidStudents }}
            </div>
          </div>
          <svg
            class="summary-donut"
            viewBox="0 0 36 36"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="donut-track"
              cx="18"
              cy="18"
              fill="none"
              r="15.9"
              stroke="#e9ecef"
              stroke-width="3.2"
            />
            <circle
              class="donut-segment"
              cx="18"
              cy="18"
              fill="none"
              r="15.9"
              :stroke="paidPercent > 0 ? '#FDAC41' : '#E1E1E1'"
              :stroke-dasharray="`${paidPercent} ${100 - paidPercent}`"
              stroke-dashoffset="25"
              stroke-linecap="round"
              stroke-width="3.2"
            />
            <text
              class="donut-label"
              dominant-baseline="middle"
              fill="#333"
              font-size="8"
              font-weight="bold"
              text-anchor="middle"
              x="18"
              y="18"
            >
              {{ paidPercent }}%
            </text>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentInfoGroupedSummary',
  props: {
    value: {
      type: Object,
      default: () => ({
        totalProcessedPayments: 0,
        totalStudents: 0,
        totalProcessedStudents: 0,
        totalPaidStudents: 0,
      }),
    },
  },
  computed: {
    processedPercent() {
      if (!this.value.totalStudents) return 0;
      return Math.round(
        (this.value.totalProcessedStudents / this.value.totalStudents) * 100
      );
    },
    paidPercent() {
      if (!this.value.totalStudents) return 0;
      return Math.round(
        (this.value.totalPaidStudents / this.value.totalStudents) * 100
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.grouped-summary {
  background: map-get($colors, 'secondary-3');
  padding: 12px;
  border-radius: 4px;
}

.summary-row {
  gap: 12px;
  margin: 0;

  > [class*='col'] {
    padding-left: 0;
    padding-right: 0;
  }
}

.summary-item {
  background: map-get($colors, 'white');
  padding: 12px;
  border-radius: 4px;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
}

@media (max-width: 767px) {
  .summary-item + .summary-item {
    border-left: none;
    border-top: 1px solid #e9ecef;
    padding-top: 0.75rem;
  }
}

.summary-donut {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

.font-20 {
  font-size: 20px;
}
</style>
